
export default {
  name: 'AssignCustomersEULA',

  layout: 'terms',
}
